export class Config {
  static appNameShort = "Photojoiner";
  static appNameCollegeMaker = "Photojoiner | Collage Maker";
  static siteDomain = "https://www.photojoiner.com";
  static attachmentBaseUrl = "https://storage.photojoiner.com/api/attachments/";
  static colors = {
    primary: "#00bcd4",
  };
}
